import { serving_budgets_namespaceObject, fitTurnsToWindow } from "./7.js";
const BOS = 256;
const EOS = 257;
const PAD = 258;
const SEP = 259;
const EXPORT_T = 256;
const BUDGETS = serving_budgets_namespaceObject.R;
function scenarioBudget(scenario) {
    const budget = BUDGETS[scenario];
    if (void 0 === budget) throw new Error(`no serving budget declared for scenario ${scenario}`);
    return budget;
}
function conversationContext(turns) {
    const ids = [];
    for (const [index, turn] of turns.entries()){
        if (index) ids.push(SEP);
        ids.push(...new TextEncoder().encode(turn));
    }
    return ids;
}
function fitConversationPrompt(scenario, turns, requestedMaxNew, maxSeq = scenarioBudget(scenario).maxSeq) {
    const budget = scenarioBudget(scenario);
    const context = conversationContext(fitTurnsToWindow(turns, Math.min(budget.maxUser, maxSeq - 2)));
    const keep = Math.min(context.length, budget.maxUser, maxSeq - 2);
    const maxNew = Math.max(1, Math.min(Math.max(0, requestedMaxNew), budget.maxNew, maxSeq - keep - 2));
    return {
        prompt: [
            BOS,
            ...context.slice(context.length - keep),
            SEP
        ],
        maxNew
    };
}
function somaFullGraphCanServe(promptLength, maxNew) {
    return promptLength > 0 && maxNew > 0 && promptLength + maxNew <= EXPORT_T;
}
function argmaxAt(logits, pos, vocab) {
    let best = 0;
    let bestVal = -1 / 0;
    const off = pos * vocab;
    for (const [v, x] of logits.subarray(off, off + vocab).entries())if (x > bestVal) {
        bestVal = x;
        best = v;
    }
    return best;
}
async function cachedStepDecode(sess, prompt, maxNew, stopSequence) {
    const layers = sess.inputNames.filter((name)=>name.startsWith('k_in_')).length;
    if (!layers) throw new Error('cached-step graph has no cache inputs');
    const feeds = {};
    for(let i = 0; i < layers; i++){
        const kd = sess.inputShape(`k_in_${i}`);
        const hd = Number(kd?.[3]);
        const kvh = Number(kd?.[1]);
        const dModel = Number(sess.inputShape(`h_in_${i}`)?.[1]);
        if (!Number.isFinite(hd) || !Number.isFinite(kvh) || !Number.isFinite(dModel)) throw new Error('cached-step graph has incompatible cache metadata');
        feeds[`k_in_${i}`] = sess.float32(new Float32Array(0), [
            1,
            kvh,
            0,
            hd
        ]);
        feeds[`v_in_${i}`] = sess.float32(new Float32Array(0), [
            1,
            kvh,
            0,
            hd
        ]);
        feeds[`h_in_${i}`] = sess.float32(new Float32Array(dModel), [
            1,
            dModel
        ]);
    }
    const out = [];
    let pos = 0;
    const first = prompt[0];
    if (void 0 === first) throw new Error('cached-step decode needs a non-empty prompt');
    let token = first;
    const advance = async (next)=>{
        feeds.tok = sess.int64(BigInt64Array.of(BigInt(next)), [
            1,
            1
        ]);
        feeds.pos = sess.int64(BigInt64Array.of(BigInt(pos++)), []);
        const res = await sess.run(feeds);
        for(let i = 0; i < layers; i++){
            const k = res[`k_out_${i}`];
            const v = res[`v_out_${i}`];
            const h = res[`h_out_${i}`];
            if (void 0 === k || void 0 === v || void 0 === h) throw new Error(`cached-step graph returned no cache for layer ${i}`);
            feeds[`k_in_${i}`] = k;
            feeds[`v_in_${i}`] = v;
            feeds[`h_in_${i}`] = h;
        }
        const logits = res.logits;
        const vocab = logits?.dims.at(-1);
        if (void 0 === logits || void 0 === vocab) throw new Error('cached-step graph returned no logits');
        return argmaxAt(logits.data, 0, vocab);
    };
    for (const id of prompt)token = await advance(id);
    for(let i = 0; i < maxNew && token !== EOS; i++){
        if (token < 256) out.push(token);
        if (stopSequence?.length && out.length >= stopSequence.length && stopSequence.every((byte, index)=>out[out.length - stopSequence.length + index] === byte)) break;
        token = await advance(token);
    }
    return out;
}
export { BOS, EOS, EXPORT_T, PAD, SEP, argmaxAt, cachedStepDecode, conversationContext, fitConversationPrompt, somaFullGraphCanServe };
